<template>
  <section
    :style="{ 'background-image': 'url(' + backgroundImageSrc + ')' }"
    class="explaination">
    <h1>{{ textData[lang.key].explaination.title }}</h1>
    <p>{{ textData[lang.key].explaination.text1 }}</p>
    <p>{{ textData[lang.key].explaination.text2 }}</p>
    <p>{{ textData[lang.key].explaination.text3 }}</p>
    <AppLink/>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import setting from '@/setting.js'
import AppLink from '@/components/molecules/AppLink'

export default {
  name: 'Explaination',
  components: {
    setting,
    mapGetters,
    AppLink
  },
  computed: {
    ...mapGetters(['textData', 'lang', 'mediaType']),
    backgroundImageSrc: function () {
      let imageSrc = ''
      if (this.mediaType === 'pc') {
        imageSrc = require('@/assets/img/bk-about.png')
      } else {
        imageSrc = require('@/assets/img/bk-about-sp.png')
      }
      return imageSrc
    }
  },
  data () {
    return {
      setting
    }
  },
  methods: {
  },
  mounted () {
  },
  created () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  activated () {
  }
}
</script>
<style lang="postcss" scoped>
  @import '../../assets/css/mixins.css';
  @import '../../assets/css/variables.css';

  .explaination {
    /* padding-bottom: 70px; */
    background-repeat: no-repeat;
    background-position: bottom;
    background-size: auto 80%;
    width: 100%;
    height: auto;
    & h1 {
      color: #CC3454;
      font-size: 40px;
      text-align: center;
      padding: 70px 0;
    }
    & p {
      max-width: 1020px;
      margin: auto;
      color: #222222;
      font-size: 24px;
      line-height: 52px;
      text-align: center;
      padding: 0 20px;
    }
    & p:nth-child(4) {
      margin-bottom: 50px;
    }
    & .app-link {
      padding-bottom: 70px;
    }
  }
  @media (--breakPoint) {
    .explaination {
      padding: 20px;
      padding-bottom: 40px;
      height: auto;
      & h1 {
        font-size: 28px;
        padding: 40px 0;
      }
      & p {
        width: 100%;
        font-size: 18px;
        line-height: 32px;
        padding: 0;
      }
      & p:nth-child(4) {
        margin-bottom: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/templates/Explaination.vue